import './includes/submenu-toggle';
import './includes/content-slider';
import './includes/search-popover';
import './includes/busy-submit';
import { getIcon } from './includes/icons';

// Expose icon utility globally
window.sitchco = window.sitchco || {};
window.sitchco.getIcon = getIcon;
